// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Monaco from '../_raw/flag/icon_flag_monaco.png';

export default () => <img src={Monaco} alt="Monaco" />;
